import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isDbInitialized: false,
  // url: window.location.pathname.split("/")[0],
  url: "http://kirtan1.pcb.click",
  // url: "http://localhost:5200",
};

export const DBSlice = createSlice({
  name: "dbSlice",
  initialState,
  reducers: {
    setDbStatus: (state, action) => {
      state.isDbInitialized = action.payload;
    },
  },
});

export const { setDbStatus } = DBSlice.actions;

export default DBSlice.reducer;
